module.exports = __webpack_public_path__ + "static/media/0.16ff3b09.svg";